import { useState } from "react";
import "./assistant.css";
import AssistantPng from "../img/assistant.png";
import { IoReload } from "react-icons/io5";
import { RxCross1 } from "react-icons/rx";
import TypingLoader from "./TypingLoader";
import Products from "../components/dataFiles/ProductData";

export default function Assistant() {
  const [chatOpen, setChatOpen] = useState(false);
  const [input, setInput] = useState("");
  const [users, setUsers] = useState([]);
  const [messages, setMessages] = useState([
    { role: "bot", text: "Hi, I’m your assistant. Do you need help?" }
  ]);
  const [stage, setStage] = useState("intro");
  const [queryType, setQueryType] = useState("");
  const [usedQueryTypes, setUsedQueryTypes] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const YES = "yes";
  const NO = "no";

  const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);

  const pushTypingThen = (next, delay = 500) => {
    const id = Date.now();
    setMessages(prev => [...prev, { role: "typing", id }]);
    setTimeout(() => {
      setMessages(prev => prev.filter(m => m.id !== id));
      next();
    }, delay);
  };

  const botSay = text => {
    const capitalizedText = text
      .split("\n")
      .map(line => capitalize(line.trim()))
      .join("\n");
    pushTypingThen(() =>
      setMessages(prev => [...prev, { role: "bot", text: capitalizedText }])
    );
  };

  const addUser = text =>
    setMessages(prev => [...prev, { role: "user", text: capitalize(text) }]);

  const resetChat = () => {
    setMessages([{ role: "bot", text: "Hi, I’m your assistant. Do you need help?" }]);
    setUsers([]);
    setStage("intro");
    setQueryType("");
    setUsedQueryTypes([]);
    setSelectedProduct(null);
  };

  const toggleChat = e => {
    e.preventDefault();
    const open = !chatOpen;
    setChatOpen(open);
    if (!open) resetChat();
  };

  const handleNameSubmit = e => {
    e.preventDefault();
    if (!input.trim()) return;
    const name = input.trim();
    addUser(name);
    setUsers([name]);
    setInput("");
    botSay(`Nice to meet you, ${name}. Do you have any query regarding our products?`);
    setStage("confirmQuery");
  };

  const handleYesNo = value => {
    addUser(value);
    if (stage === "intro") {
      if (value === YES) {
        botSay("Ok, then kindly share your name.");
        setStage("needName");
      } else {
        endConversation();
      }
    } else if (stage === "confirmQuery") {
      if (value === YES) {
        botSay("Great! Please choose your query type below.");
        setStage("awaitQueryType");
      } else {
        endConversation();
      }
    }
  };

  const endConversation = () => {
    pushTypingThen(() => botSay("Alright, feel free to ask anything anytime."));
    setTimeout(() => setChatOpen(false), 2000);
  };

  const handleQueryTypeChange = e => {
    const value = e.target.value;
    setQueryType(value);
    addUser(value);

    if (!usedQueryTypes.includes(value)) {
      setUsedQueryTypes(prev => [...prev, value]);
    }

    if (value === "price") {
      botSay("Click the button below to get our latest price list on WhatsApp.");
      setStage("repeatQuery");
    } else if (value === "product") {
      botSay("Please select a product:");
      setStage("awaitProduct");
    } else if (value === "other") {
      botSay("Click the button below to get more information on WhatsApp.");
      setStage("repeatQuery");
    }
  };

  const handleProductSelect = e => {
    const title = e.target.value;
    addUser(title);
    setSelectedProduct(title);
    botSay(`What would you like to know about ${title}?`);
    setStage("productDetailType");
  };

  const handleProductDetailType = e => {
    const type = e.target.value;
    addUser(type);

    if (type === "other") {
      window.open(`https://wa.me/919779096815?text=Hi%20team%2C%20please%20share%20more%20about%20${selectedProduct}`, "_blank");
      return;
    }

    const prod = Products.find(p => p.title === selectedProduct);
    let content = "";

    if (type === "feature") {
      content = Array.isArray(prod.features)
        ? prod.features.map((f, i) => `${i + 1}. ${f}`).join("\n")
        : prod.features;

      pushTypingThen(() => {
        botSay(`Features of ${selectedProduct}:\n${content}`);
        pushTypingThen(() => {
          botSay("Would you like to see the description or contact on WhatsApp?");
          setStage("productFollowUp");
        });
      }, 1000);
    } else if (type === "description") {
      content = prod.description;
      pushTypingThen(() => {
        botSay(`Description of ${selectedProduct}:\n${content}`);
        setStage("repeatQuery");
      });
    }
  };

  const getRemainingQueryTypes = () => {
    const all = ["price", "product", "other"];
    return all.filter(q => !usedQueryTypes.includes(q));
  };

  const YesNoGroup = ({ onSelect }) => (
    <form className="radio-group" onChange={e => onSelect(e.target.value)}>
      <label><input type="radio" name="yesno" value="yes" /> Yes</label>
      <label><input type="radio" name="yesno" value="no" /> No</label>
    </form>
  );

  return (
    <div className="chat-wrapper col-12 col-sm-10 col-md-5 col-lg-3">
      {chatOpen ? (<>{chatOpen && (
        <div className="assistant-container">
          <header className="chat-header d-flex justify-content-between">
            Assistant
            <div className="d-flex gap-3">
              <IoReload onClick={resetChat} />
              <RxCross1 onClick={toggleChat} />
            </div>
          </header>

          <div className="chat-body">
            {messages.map((m, i) =>
              m.role === "typing" ? (
                <TypingLoader key={m.id} />
              ) : (
                <div key={i} className={`bubble ${m.role === "bot" ? "bubble-bot" : "bubble-user"}`} style={{ whiteSpace: 'pre-line' }}>
                  {m.text}
                </div>
              )
            )}

            {stage === "intro" && <YesNoGroup onSelect={handleYesNo} />}

            {stage === "needName" && (
              <form className="row form assistantForm" onSubmit={handleNameSubmit}>
                <input className="col-9" value={input} onChange={e => setInput(e.target.value)} placeholder="Enter your name…" />
                <button type="submit" className="col-3">Send</button>
              </form>
            )}

            {stage === "confirmQuery" && <YesNoGroup onSelect={handleYesNo} />}

            {stage === "awaitQueryType" && (
              <form className="radio-group" onChange={handleQueryTypeChange}>
                <label><input type="radio" name="query" value="price" /> Price</label>
                <label><input type="radio" name="query" value="product" /> Product</label>
                <label><input type="radio" name="query" value="other" /> Other</label>
              </form>
            )}

            {stage === "awaitProduct" && (
              <form className="radio-group" onChange={handleProductSelect}>
                {Products.map(p => (
                  <label key={p._id}>
                    <input type="radio" name="product" value={p.title} /> {p.title}
                  </label>
                ))}
              </form>
            )}

            {stage === "productDetailType" && (
              <form className="radio-group" onChange={handleProductDetailType}>
                <label><input type="radio" name="detailType" value="feature" /> Feature</label>
                <label><input type="radio" name="detailType" value="description" /> Description</label>
                <label><input type="radio" name="detailType" value="other" /> Other</label>
              </form>
            )}

            {stage === "productFollowUp" && (
              <form className="radio-group" onChange={handleProductDetailType}>
                <label><input type="radio" name="followup" value="description" /> Description</label>
                <label><input type="radio" name="followup" value="other" /> Other</label>
              </form>
            )}

            {queryType === "price" && (
              <a className="bubble-bot bubble btn btn-success mt-2" id="whatsappRef"
                href="https://wa.me/919779096815?text=Hi%20team%2C%20please%20share%20product%20prices."
                target="_blank" rel="noopener noreferrer">Get Price on WhatsApp</a>
            )}

            {queryType === "other" && (
              <a className="bubble-bot bubble btn btn-primary mt-2" id="whatsappRef"
                href="https://wa.me/919779096815?text=Hi%20team%2C%20please%20share%20more%20information."
                target="_blank" rel="noopener noreferrer">Chat on WhatsApp</a>
            )}

            {stage === "repeatQuery" && getRemainingQueryTypes().length > 0 && (
              <form className="radio-group" onChange={handleQueryTypeChange}>
                {getRemainingQueryTypes().map(q => (
                  <label key={q}>
                    <input type="radio" name="query_repeat" value={q} /> {capitalize(q)}
                  </label>
                ))}
              </form>
            )}
          </div>
        </div>
      )}
</>) : (<>
 <div className="AssistantPng-container" onClick={toggleChat}>
        <img src={AssistantPng} className="AssistantPng" alt="Assistant Icon" />
      </div> 
</>)}
      
    </div>
  );
}
